import useAccountStore from '@/account/accountStore'
import type { Account } from '@/common/types'

export function useCurrentAccount(): Account | null {
    return useAccountStore((s) => s.getActiveAccount())
}
